import {MEMBER_FOCUS_BUTTON_CLASS} from "./interactions";
import {capitalize} from "./utilities";

const SELECTED_MEMBER_CONTAINER_ID = "selected-member-container";

const SERVICE_TYPE_STYLING = {
    "Both": "bg-amber-500 text-white", "Therapy": "bg-green-500", "Support Work": "bg-blue-500 text-white", "": "hidden"
}

export const renderMemberDetails = (member) => {
    const container = document.getElementById(SELECTED_MEMBER_CONTAINER_ID);
    if (!container || !member) return; // Don't render anything
    container.innerHTML = memberDetailsTemplate(member);
}

const memberDetailsTemplate = (member) => {

    return `
<div class="selected-member shadow-md shadow-slate-400 rounded-lg overflow-hidden flex flex-col">
  <div class="px-4 pt-4 flex justify-between">
  
    ${member.avatar ? `<img src="${member.avatar}" alt="${member.first_name}" class="h-14 w-14 rounded-full " />` : `<svg class="h-14 w-14 rounded-full opacity-50" fill="currentColor" viewBox="0 0 24 24"><path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" /></svg>`}
      <div>
      <button class="${SERVICE_TYPE_STYLING[capitalize(member.type_of_service.replace('_', ' '))]} py-2 px-4 rounded-md">
        ${capitalize(member.type_of_service.replace('_', ' '))}
      </button>
    </div>
  </div>
  <div class="p-4">
    <div class="flex flex-row items-center justify-start">
      <button data-member-id="${member.id}" class="${MEMBER_FOCUS_BUTTON_CLASS.substring(1)} text-black opacity-50 hover:text-ascendPurple-dark transition p-1 -ms-1 hover:opacity-100">
        <i class="fas fa-location-crosshairs cursor-pointer pointer-events-none"></i>
      </button>
      <a href="/members/${member.id}">
        <h2 class="text-xl font-semibold hover:underline cursor-pointer">${member.first_name} ${member.last_name}</h2>
      </a>
    </div>
    <p class="text-gray-700">${member.full_address ?? "No address entered"}</p>
    <p class="text-gray-700">
      Availability: <br/>${member.availability ?? "No availability entered"}
    </p>
  </div>
</div>
    `;
}
